/* @ngInject */
const myDispatchDisplay = () => {
  return {
    restrict: 'E',
    scope: {
      myDispatch: '=myDispatch',
    },

    template: require('./myDispatchDisplay.html'),

    /* @ngInject */
    controller: (
      $scope,
      utils,
      $$dispatch
    ) => {
      $scope.utils = utils
      $scope.fields = $$dispatch.metadata.fields
      $scope.badges = $$dispatch.metadata.badges
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myDispatchDisplay



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/directives/display/myDispatchDisplay.js